import React, { useState } from 'react';
import { InlineDatePickerProps } from '@components/DatePickerComponent/InlineDatePicker';
import { Input, InputProps, PopoverProps } from 'antd';
import DatePickerPopover from '@components/DatePickerComponent/DatePickerPopover';
import classNames from 'classnames';
import moment from 'moment';
import { ReactComponent as CalendarSvg } from '@assets/icons/calendar.svg';
import { ReactComponent as CalendarNotSelectedSvg } from '@assets/icons/calendar-v2.svg';
import './DatePickerInput.less';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';

interface DatePickerInputProps extends InlineDatePickerProps {
  className?: string;
  bordered?: boolean;
  size?: InputProps['size'];
  placement?: PopoverProps['placement'];
  getPopupContainer?: PopoverProps['getPopupContainer'];
  placeholder?: string;
  disabled?: boolean;
  readonly?: boolean;
  clearableTime?: boolean;
}

const endOfDayTime = moment().endOf('day');

export default function DatePickerInput(props: DatePickerInputProps) {
  const {
    bordered,
    size,
    placement,
    placeholder,
    readonly,
    disabled,
    clearable,
    showTime,
    ...otherProps
  } = props;
  const [value, setValue] = useState(props.value);
  if (
    props.value !== undefined &&
    props.value?.valueOf() !== value?.valueOf()
  ) {
    setValue(props.value);
  }
  const defaultTime = props.defaultTime ?? endOfDayTime;
  const nonDefaultTimeSelected =
    value &&
    (value.hours() !== defaultTime.hours() ||
      value.minutes() !== defaultTime.minutes());
  const formattedDate = value ? moment(value).format('ll') : '';
  const formattedTime =
    showTime && nonDefaultTimeSelected ? moment(value).format('LT') : '';
  const showClearIcon = !readonly && !disabled && !!clearable && !!value;
  return (
    <DatePickerPopover
      {...otherProps}
      placement={placement ?? 'bottomRight'}
      trigger={disabled || readonly ? [] : 'click'}
      clearable={clearable}
      showTime={showTime}
      value={value}
    >
      <div>
        <Input
          className={classNames({
            'date-picker-input': true,
            'date-picker-input--disabled': disabled,
            'date-picker-input--readonly': readonly
          })}
          disabled={disabled}
          size={size}
          bordered={bordered}
          value={formattedDate}
          suffix={
            <span className="date-picker-input__suffix">
              {!value && (
                <span className="date-picker-input__placeholder">
                  {placeholder}
                </span>
              )}
              {formattedDate && (
                <span className="date-picker-input__date">{formattedDate}</span>
              )}
              {formattedTime && (
                <span className="date-picker-input__time">{formattedTime}</span>
              )}
              {showClearIcon && (
                <CrossSvg
                  className="date-picker-input__suffix-icon"
                  onClick={(e: MouseEvent) => {
                    e.stopPropagation();
                    setValue(null);
                    if (props.onChange) props.onChange(null);
                  }}
                />
              )}
              {!showClearIcon && !value && (
                <CalendarNotSelectedSvg className="date-picker-input__suffix-icon" />
              )}
              {!showClearIcon && value && (
                <CalendarSvg className="date-picker-input__suffix-icon" />
              )}
            </span>
          }
        />
      </div>
    </DatePickerPopover>
  );
}
